<template>
  <a-modal
    title="UpdateInfo"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    :maskClosable='maskClosable'
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Phone">
              <a-input placeholder="Please enter phone number" v-decorator="[ 'mobile', validatorRules.mobile]" readOnly/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="ID CardNo.">
              <a-input placeholder="Please enter ID cardNo." v-decorator="[ 'curp', validatorRules.curp]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Address1">
              <a-input placeholder="Please enterAddress1" v-decorator="[ 'address1', validatorRules.address1]"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="City">
              <a-input placeholder="Please enterCity" v-decorator="[ 'city', validatorRules.city]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Address2">
              <a-input placeholder="Please enterAddress2" v-decorator="[ 'address2', validatorRules.address2]"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="State">
<!--              <a-input placeholder="Please enter state" v-decorator="[ 'states', validatorRules.states]"/>-->
              <a-select v-decorator="[ 'states', validatorRules.states]" :placeholder="$t('select') + ' State'">
                <a-select-option v-for='item in stateses' :key='item'>
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>

          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Address3">
              <a-input placeholder="Please enterAddress3" v-decorator="[ 'address3', validatorRules.address3]"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Zip Code">
              <a-input placeholder="Please enterZip Code" v-decorator="[ 'postCode', validatorRules.postCode]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Contract">
              <a-input placeholder="Please enterContractAddress" v-decorator="[ 'contractUrl', validatorRules.contractUrl]"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Name">
              <a-input placeholder="Please enterName" v-decorator="[ 'name', validatorRules.name]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="24" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="FullAddress">
              <a-input placeholder="Please enterFullAddress" v-decorator="[ 'address', validatorRules.address]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" style='text-align: right' class="table-page-search-submitButtons">
          <a-button type="primary" @click="close" v-if='pageType=="detail"'>Close</a-button>
          <a-button type="primary" @click="handleOk" v-if='pageType=="edit"'>Save</a-button>
        </a-row>
      </a-form>
    </a-spin>
    <a-card style="margin-top: 24px" type="inner">
      <a-row :gutter="24">
        <a-col :md="12" :sm="12">
      <a-card
        style="margin-top: 24px"
        title="User Image"
        type="inner"
        v-viewer="viewOptions">
        <div v-for="(item, index) in imageInfos">
          <div class="file-box">
            <div class="file-item">
              <!--            <p class="file-label">{{ FILE_TYPE[item.imgType] }}</p>-->
              <canvas class="file-preview" style="width: 500px; height: auto;" v-image-to-canvas="item.imgUrl" preview="0"></canvas>
            </div>
          </div>
        </div>
      </a-card>
        </a-col>
        <a-col :md="12" :sm="12">
          <a-card
            style="margin-top: 24px"
            title="Internal Action"
            type="inner"
            v-viewer="viewOptions">
            <div class="table-page-search-wrapper"><a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="CurrentStatus(Display)">
                  <a-select v-model="oldStatus" :placeholder="$t('select')" style="width: 100%" readonly>
                    <a-select-option v-for='item in statuses' :key='item.dictValue'>
                      {{item.dictTextCn}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="ErrorInfo(Display)">
                  <a-input placeholder="No" v-model="oldErrorMessage" readonly></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="Internal Group Name">
                  <a-input placeholder="No" v-model="oldInnerGroupId" readonly></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="Internal Task ID">
                  <a-input placeholder="No" v-model="oldInnerTaskId" readonly></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="Third-party Group Name">
                  <a-input placeholder="No" v-model="oldThirdGroupId" readonly></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="24" :sm="24">
                <a-form-item label="Third-party Task ID">
                  <a-input placeholder="No" v-model="oldThirdTaskId" readonly></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            </a-form></div>
            <a-card
              style="margin-top: 24px"
              title="TagAction"
              type="inner"
              v-viewer="viewOptions">
              <div class="table-page-search-wrapper"><a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="24" :sm="24">
                  <a-form-item label="Tag">
                    <a-select v-model="oldTags" :placeholder="$t('select')" style="width: 100%" mode="multiple" :allowClear='allowClear'>
                      <a-select-option v-for='item in tags' :key='item.dictValue'>
                        {{item.dictValue}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :sm="12">
                  <a-button type="primary" @click="addTags">Add Tag</a-button>
                  <a-button type="primary" @click="close" >Close</a-button>
                </a-col>
              </a-row>
              </a-form></div>
            </a-card>
            <a-card
              style="margin-top: 24px"
              title="StatusAction"
              type="inner"
              v-viewer="viewOptions" v-if='pageType == "edit"'>
              <div class="table-page-search-wrapper"><a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="24" :sm="24">
                  <a-form-item label="No Tax Filing Reason">
                    <a-input placeholder="Please enterNo Tax Filing Reason" v-model="errorMessage" :allowClear='allowClear' ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="24" :sm="24">
                  <a-button type="primary" @click="noFilingTax">No Tax Filing</a-button>
                  <a-button type="primary" @click="close" >Close</a-button>
                </a-col>
                <a-col :md="24" :sm="24">
                  <a-divider style="height: 2px; background-color: #7cb305" v-if='oldStatus==10'/>
                  <a-button type="primary" @click="filingTaxSuccess" v-if='oldStatus==10'>Tax Filed Successfully</a-button>
                  <a-button type="primary" @click="close" v-if='oldStatus==10'>Close</a-button>
                </a-col>
              </a-row>
              </a-form></div>
            </a-card>
<!--            <a-card-->
<!--              style="margin-top: 24px"-->
<!--              title="After-tax operation"-->
<!--              type="inner"-->
<!--              v-viewer="viewOptions">-->
<!--              <div class="table-page-search-wrapper"><a-form layout="inline">-->
<!--                <a-row :gutter="24">-->
<!--                  <a-col :md="24" :sm="12">-->

<!--                    <a-form-item-->
<!--                      :labelCol="labelCol"-->
<!--                      :wrapperCol="wrapperCol"-->
<!--                      label="Upload tax voucher">-->
<!--                      <a @click="uploadtax" style="margin: 10px">-->
<!--                        Upload tax voucher-->
<!--                      </a>-->
<!--                    </a-form-item>-->
<!--                  </a-col>-->
<!--                </a-row>-->
<!--              </a-form></div>-->
<!--            </a-card>-->
          </a-card>
        </a-col>
      </a-row>
    </a-card>

    <a-modal
      v-model:visible="visibleUploadtax"
      title="Upload stamp duty"
      :ok-text="$t('confirm')"
      :cancel-text="$t('cancel')"
    >
      <a-form>
        <a-upload :customRequest='customRequest'
                  :remove='remove'
                  v-model:file-list="fileList">
          <a-button v-if='fileList.length < 1'>{{ $t("order.upload") }}</a-button>
        </a-upload>
      </a-form>
  </a-modal>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { filingTaxDetail, filingTaxUpdate,uploadTax } from '@/webpublicapi/order'
import imageMixin from '@/mixins/image-mixin';
export default {
  name: "OrderFilingTaxUpdateModel",
  props: {
    oldTags:{
      type: Array,
      default: [],
    },
    oldErrorMessage: {
      type: String,
      default: null,
    },
    // oldStatus: {
    //   type: String,
    //   default: null,
    // },
    statuses: {
      type: Array,
      default: []
    },
    tags: {
      type: Array,
      default: []
    },
    pageType: {
      type: String,
      default: null
    },
    fourToOtherSwitch:{
      type: String,
      default: null
    },
    oldInnerGroupId: {
      type: String,
      default: null,
    },
    oldThirdGroupId: {
      type: String,
      default: null,
    },
    oldInnerTaskId: {
      type: String,
      default: null,
    },
    oldThirdTaskId: {
      type: String,
      default: null,
    },
  },
  mixins: [imageMixin],
  data () {
    return {
      title:"Action",
      visible: false,
      allowClear: true,
      readOnly: true,
      fileList:[],
      imageLoading:[],
      imgCount: 0,
      visibleUploadtax: false,
      orderIdForTax: null,
      oldStatus: '',
      stateses: ["Johor", "Kedah", "Kelantan", "Luar Negara", "Melaka", "Negeri Sembilan", "Pahang", "Perak", "Perlis", "Pulau Pinang", "Sabah", "Sarawak", "Selangor", "Terengganu", "Wilayah Persekutuan Kuala Lumpur", "Wilayah Persekutuan Labuan", "Wilayah Persekutuan Putrajaya"],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      imageInfos: [],
      id: null,
      errorMessage: '',
      confirmLoading: false,
      maskClosable: false,
      form: this.$form.createForm(this),
      validatorRules:{
        name:{
          rules: [
            { required: true, message: 'Please input name!' },
          ]},
        mobile:{
          rules: [
            { required: true, message: 'Please input mobile!' },
          ]},
        curp:{
          rules: [
            { required: true, message: 'Please input curp!' },
          ]},
        address:{
          rules: [
            { required: false, message: 'Please input address!' },
          ]},
        address1:{
          rules: [
            { required: true, message: 'Please input address1!' },
          ]},
        address2:{
          rules: [
            { required: true, message: 'Please input address2!' },
          ]},
        address3:{
          rules: [
            { required: false, message: 'Please input address3!' },
          ]},
        city:{
          rules: [
            { required: true, message: 'Please input city!' },
          ]},
        states:{
          rules: [
            { required: true, message: 'Please input states!' },
          ]},
        postCode:{
          rules: [
            { required: true, message: 'Please input postCode!' },
          ]},
        contractUrl:{
          rules: [
            { required: true, message: 'Please input contractUrl!' },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.id = record.id
      this.oldStatus = record.status
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'totalPeriod', 'applyDuration', 'applyAmount', 'name', 'mobile', 'curp', 'address', 'address1', 'address2', 'address3', 'city', 'states', 'postCode', 'contractUrl'))
      });
      this.detail(record.id);
      this.errorMessage = ''
      // this.fillCurStatus();
    },
    // fillCurStatus() {
    //   document.getElementById('curStatus').value = this.showCurStatus()
    // },
    detail(id) {
      this.imageInfos=[];
      var model= {
        'id': id
      }
      filingTaxDetail(model).then((res) => {
        if (res.code === 1000) {
          this.imageInfos = res.data.imageInfos
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    showCurStatus() {
      for (const st in this.statuses) {
        if(this.statuses[st].dictValue == this.oldStatus) {
          return this.oldStatus+"-"+this.statuses[st].dictTextCn;
        }
      }
    },
    handleOk () {
      if("detail" === this.pageType) {
        this.close();
        return;
      }
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    noFilingTax() {
      var model = {
        id: this.id,
        status: '5',
        errorMessage: this.errorMessage
      }
      filingTaxUpdate(model).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    filingTaxSuccess() {
      var model = {
        id: this.id,
        status: '4'
      }
      filingTaxUpdate(model).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    handleCancel () {
      this.close()
    },
    addTags() {
      if(this.oldTags.length <=0) {
        return;
      }
      var model = {
        id: this.id,
        tag: this.oldTags.join(",")
      }
      filingTaxUpdate(model).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    uploadtax() {
      this.visibleUploadtax = true;
      this.orderIdForTax = this.id;
    },
    remove(file) {
      // console.log(file)
      var newList = [];
      for(var item in this.fileList){
        var theFile = this.fileList[item];
        if(theFile.attCode === file.response.data.attachmentCode) {
          continue;
        }
        newList.push(theFile);
      }
      this.fileList = newList;
      // console.log(newList)
      return true;
    },
    customRequest(file){
      const form = new FormData();
      var theCount = this.imgCount;
      this.imgCount = this.imgCount + 1;
      this.imageLoading[Number(theCount)] = 'loading'
      form.append('file', file.file)
      uploadTax(form, this.orderIdForTax).then(res => {
        if (res.code === 1000) {
          file.onSuccess(res, file.file)
          file.status = 'done'
          this.imageLoading[Number(theCount)] = 'done';
          this.$message.info("success")
          file['attCode'] = res.data.attachmentCode
          this.fileList.push(file);
          // console.log(file)
        } else {
          file.onError()
          file.status = 'error'
          this.imageLoading[Number(theCount)] = 'done';
          this.$message.error(res.msg)
        }
      }).catch(e => {
        file.onError()
        file.status = 'error'
        this.imageLoading[Number(theCount)] = 'done';
        this.$message.error(e.message);
      })
    },
  }
}
</script>

<style scoped>

</style>